import {
  TableCell,
  TableRow,
  Table,
  TableContainer,
  Button
} from "@mui/material";
import { Autocomplete } from "components/Autocomplete";
import { styled } from "@mui/material/styles";
import { withTransientProps } from "core/utils/transientProps";

export const Header = styled("h3")`
  padding: ${({ theme }) => `${theme.spacing(1)} 0px 0px ${theme.spacing(1)}`};
  margin: 0px;
`;
export const EntitlementsHeader = styled("h3")`
  padding: ${({ theme }) => `${theme.spacing(2)} 0px 0px ${theme.spacing(1)}`};
  margin: 0px;
`;
export const ControlsContainer = styled("div")`
  margin: ${({ theme }) => `0px 0px ${theme.spacing(1)} `};
`;
export const AddButton = styled(Button)`
  display: inline-block;
  margin: ${({ theme }) => `${theme.spacing(2)} 0px 0px ${theme.spacing(1)}`};
`;
export const DeleteButton = styled(Button)`
  float: right;
  display: inline-block;
  margin: ${({ theme }) => `${theme.spacing(2)} 0px 0px ${theme.spacing(1)}`};
`;
export const AddAutocomplete = styled(Autocomplete)`
  display: inline-block;
  width: 25%;
`;
export const ScrollableTableContainer = styled(TableContainer)`
  height: 280px;
`;
export const ScrollableTable = styled(Table)`
  height: max-content;
`;
export const TableCellNoPadding = styled(TableCell)`
  padding: 0px;
`;
export const MembersTableRow = styled(TableRow, withTransientProps)`
  ${({ $isSaved }) => $isSaved && `background-color: rgba(0, 0, 0, 0.12);`}
`;
